<template>
  <div
    role="status"
    aria-live="polite"
    class="content"
  >
    <p class="alert" :class="levelClass">
      <strong>Error!</strong>
      {{ message }}
    </p>
  </div>
</template>

<script>
export default {

  name: 'BannerNotice',

  props: {
    message: {
      type: String,
      default: 'There was an error.',
    },
    level: {
      type: Number,
      default: 2,
    },
  },

  data() {
    return {
      levels: new Map([
        [0, 'notice'],
        [1, 'warning'],
        [2, 'danger'],
      ]),
    }
  },

  computed: {
    levelClass() {
      return `alert--${this.levels.get(this.level)}`
    },
  },
}
</script>

<style lang="scss" scoped>
.content {
  padding: 0;
}

.alert {
  padding: 1rem;
  margin: 1.5rem 0;
  border: 1px solid transparent;
  border-radius: 4px;

  &--danger {
    color: #a94442;
    background-color: #f2dede;
    border-color: #ebccd1;
  }

  &--warning {
    // TODO: add this when needed, reference Admin styles
  }

  &--danger {
    // TODO: add this when needed, reference Admin styles
  }
}
</style>
